import { render, staticRenderFns } from "./betterScroll.vue?vue&type=template&id=4ccae990"
import script from "./betterScroll.vue?vue&type=script&lang=js"
export * from "./betterScroll.vue?vue&type=script&lang=js"
import style0 from "./betterScroll.vue?vue&type=style&index=0&id=4ccae990&prod&rel=stylesheet%2Fscss&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports